module.exports = __webpack_public_path__ + "assets/img/skin_6.be8df704.jpg";